import React, { useReducer } from "react";

import { StepDispatchContext, stepInitialState, stepReducer, StepStateContext } from "./Reducer";

export function StepContextProvider({ children }: any) {
    const [stepState, stepDispatch] = useReducer(stepReducer, stepInitialState);

    return (
        <StepDispatchContext.Provider value={stepDispatch}>
            <StepStateContext.Provider value={stepState}>{children}</StepStateContext.Provider>
        </StepDispatchContext.Provider>
    );
}
